import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as M from "materialize-css/dist/js/materialize";
import 'firebase/storage';
import * as _moment from 'moment';

import * as CryptoJS from 'crypto-js';
import * as shajs from 'sha.js';

import { Observable } from '../../../node_modules/rxjs';

@Injectable({ providedIn: 'root' })
export class HelperService {
  private headers4Cors = { headers: {'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' } };
  _aesKey = 'AXe8YwuIn1zxt3FPWTZFlAa14EHdPAdN9FaZ9RQWihc=';
  _aesIv = 'tattMyanmar8kCfWuyrnqg==';
  appVersion:any = {};
  menuList = [];
  showHideDwellTime: boolean = false;

  constructor(private http: HttpClient) {
  }

  menusInit(argAcc){
    this.menuList = [];
    this.http.get('./assets/contando.json?t=' + new Date().getTime()).subscribe(res=>{
      this.appVersion = res;
      this.menuList = this.menus(argAcc, this.appVersion.allowReport);
      this.makeShowHideDwellTime(argAcc, this.appVersion.hideDwellTimeForNonSA);
      //console.log('contando:', this.appVersion.client, this.menuList);
    });
  }

  menus(argAcc, allowReport=false) {
    var _menus = [
      { title: 'Home', icon:'equalizer', badge:'3', active: false, status: false, route: '/home' },
      { title: 'Dashboard', icon:'equalizer', badge:'3', active: false, status: true, route: '/dashboard', cssCard: 'gradient-shadow gradient-45deg-light-blue-cyan', cssIcon: 'gradient-45deg-red-pink' },
      { title: 'Data Management', badge:'3', active: false, status: false, header: true, route: '' },
      { title: 'Data Viewer', icon:'chrome_reader_mode', badge:'3', active: false, status: false, route: '/data-viewer', cssCard: 'gradient-45deg-deep-orange-orange gradient-shadow' },
      { title: 'Report', icon:'assignment', badge:'3', active: false, status: true, route: '/data-report', cssCard: 'gradient-45deg-purple-deep-purple gradient-shadow' },
      { title: 'Export Data', icon:'trending_down', badge:'3', active: false, status: false, route: '' },
      { title: 'Import Data', icon:'trending_up', badge:'3', active: false, status: false, route: '' },
      { title: 'Administration', badge:'3', active: false, status: false, header: true, route: '' },
      { title: 'Settings', icon:'settings', badge:'3', active: false, status: false, route: '/settings', cssCard: 'red', cssIcon: 'gradient-45deg-red-pink' },
      { title: 'User Mgmt', icon:'people_outline', badge:'3', active: false, status: false, route: '/users', cssCard: 'gradient-shadow gradient-45deg-green-teal', cssIcon: 'gradient-45deg-red-pink'},
      { title: 'Templates', icon:'assignment', badge:'3', active: false, status: false, route: '/templates' },
      { title: 'Logs', icon:'chrome_reader_mode', badge:'3', active: false, status: false, route: '' },
      { title: 'Analytics', icon:'show_chart', badge:'3', active: false, status: false, route: '/dashboardV02A', cssCard: 'gradient-shadow gradient-45deg-light-blue-cyan', cssIcon: 'gradient-45deg-red-pink' },
      { title: 'Logout', icon:'lock_outline', badge:'3', active: false, status: true, route: '/logout', noCard: true },
      { title: 'logo', icon:'', badge:'3', active: false, status: true, route: '', noCard: true },
      {
        title: 'Dashboard', icon:'settings_input_svideo', badge:'3', active: false, status: false,
        menus:[
          { title: 'Modern', icon: 'radio_button_unchecked', active: false },
          { title: 'eCommerce', icon: 'radio_button_unchecked' },
          { title: 'Analytics', icon: 'radio_button_unchecked' }
        ]
      },
      // {
      //   title: 'Dashboard', icon:'settings_input_svideo', badge:'3', active: false,
      //   menus:[
      //     { title: 'Modern', icon: 'radio_button_unchecked', active: false },
      //     { title: 'eCommerce', icon: 'radio_button_unchecked' },
      //     { title: 'Analytics', icon: 'radio_button_unchecked' }
      //   ]
      // },
      //{ title: 'Analytics', icon:'show_chart', badge:'3', active: false, status: false, route: '/dashboardV02A', cssCard: 'gradient-shadow gradient-45deg-light-blue-cyan', cssIcon: 'gradient-45deg-red-pink' }
       
    ];
    if(argAcc.role == 'GEEK' || argAcc.role == 'SA'){
      _menus[2].status = true;
      _menus[3].status = true;
      if(allowReport) _menus[4].status = true;  //-- report
      _menus[7].status = true;
      _menus[8].status = true;
      _menus[9].status = true;
      // _menus[12].status = true; // Analytics
    }
    else if(argAcc.role == 'ADMIN'){
      if(allowReport) _menus[4].status = true;  //-- report
      _menus[7].status = true;
      _menus[9].status = true;
      // _menus[12].status = true; // Analytics
    }
    return _menus;
  }

  makeShowHideDwellTime(argAcc, hideDwellTimeForNonSA){
    if(argAcc.role == 'GEEK' || argAcc.role == 'SA' || argAcc.role == 'ADMIN'){
      if(!hideDwellTimeForNonSA)this.showHideDwellTime = true;
    }
  }

  aesEncrypt(argText){
    var _key = CryptoJS.enc.Base64.parse(this._aesKey);
    var _iv  = CryptoJS.enc.Base64.parse(this._aesIv);

    var _cipher = CryptoJS.AES.encrypt(argText, _key, {iv: _iv});
    return _cipher.toString();
  }
  hashValue(arg){
    return shajs('sha256').update(arg).digest('hex');
  }
  hashValueBase64(arg){
    return shajs('sha256').update(arg).digest('base64');
  }
  hmac(arg){
    var _signature = CryptoJS.HmacSHA256(arg, 'F8378550-38BE-11E8-BEE9-8101A52E5AE9');
    return _signature.toString(CryptoJS.enc.Base64);
  }
  
  httpPost(url, arg): Observable<any>{
    return this.http.post(url, arg, this.headers4Cors);
  }
  
  showAlert(msg){
    M.toast({html: msg});
  }
  versionCheckStart(){
    this.http.get('./assets/contando.json?t=' + new Date().getTime()).subscribe(res=>{
        this.appVersion = res;
    });
    setInterval(()=>{
        this.versionCheck();
    }, 1000*25);
  }
  versionCheck(){
      //console.log('versionCheck');
      this.http.get('./assets/contando.json?t=' + new Date().getTime()).subscribe((res:any)=>{
          if(this.appVersion.hash != res.hash){
              this.showAlert('Refreshing for App update..');
              setTimeout(()=>{
                  //console.log('>>> New Version <<<');
                  window.location.reload();
              }, 1000*3);
          }
      });
  }

  getDaysBetweenTwoDates(dateFrom: any, dateTo: any){
    const MS_PER_DAY: number = 1000 * 60 * 60 * 24;
    const start: number = new Date(dateFrom).getTime();
    const end: number = new Date(dateTo).getTime();
    //console.log(dateFrom+':::'+dateTo)
    const daysBetweenDates: number = Math.ceil((end - start) / MS_PER_DAY);
  
    // The days array will contain a Date object for each day between dates (inclusive)
    const days: any = [] = Array.from(new Array(daysBetweenDates + 1), 
        (v, i) => _moment(new Date(start + (i * MS_PER_DAY))).format('DD MMM YYYY').toString());
        return days;
  }

}
